module.exports = __webpack_public_path__ + "img/star-fill.0d9c5307.svg";